import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export const PALETTES = ["default", "betta", "cardinal", "bee", "owl", "macaw"] as const
export type Palette = (typeof PALETTES)[number]

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}
